import React, { useState, useEffect, useRef } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { ArrowLeft, Search, Calendar, User, Clock, Tag, Facebook, Instagram, Share2, MapPin, Star, Heart, Moon, Music, Users, Sun, ChevronDown, ChevronUp, Mail, Coffee, Camera, Compass } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
import { FacebookShareButton, TwitterShareButton, WhatsappShareButton } from 'react-share';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

interface BlogPost {
  id: number;
  title: string;
  slug: string;
  excerpt: string;
  content: string;
  category: string;
  image: string;
  author: {
    name: string;
    avatar: string;
    role: string;
  };
  date: string;
  readTime: string;
  tags: string[];
  featured?: boolean;
}

const blogPosts: BlogPost[] = [
  {
    id: 1,
    title: "Ultimate Guide to Gorilla Trekking in Uganda",
    slug: "ultimate-guide-gorilla-trekking",
    excerpt: "Everything you need to know about planning your gorilla trekking adventure in Uganda's magnificent forests.",
    content: "Full content here...",
    category: "Wildlife",
    image: "https://imgur.com/LUalhrs.jpg",
    author: {
      name: "David Mugisha",
      avatar: "https://imgur.com/ERlskFe.jpg",
      role: "Wildlife Expert"
    },
    date: "2025-03-15",
    readTime: "8 min read",
    tags: ["Gorilla Trekking", "Wildlife", "Adventure"],
    featured: true
  },
  {
    id: 2,
    title: "10 Hidden Gems in Kampala You Can't Miss",
    slug: "hidden-gems-kampala",
    excerpt: "Discover the secret spots and local favorites that make Uganda's capital city truly special.",
    content: "Full content here...",
    category: "City Guide",
    image: "https://imgur.com/EzHnSsj.jpg",
    author: {
      name: "Sarah Namukasa",
      avatar: "https://imgur.com/lCTURxX.jpg",
      role: "City Guide"
    },
    date: "2025-03-12",
    readTime: "6 min read",
    tags: ["Kampala", "City Tours", "Local Life"],
    featured: true
  },
  {
    id: 3,
    title: "The Complete Safari Photography Guide",
    slug: "safari-photography-guide",
    excerpt: "Master the art of wildlife photography with expert tips for capturing Uganda's incredible animals.",
    content: "Full content here...",
    category: "Photography",
    image: "https://imgur.com/Rl4EEiV.jpg",
    author: {
      name: "Robert Kato",
      avatar: "https://imgur.com/G5VWLDc.jpg",
      role: "Safari Guide"
    },
    date: "2025-03-10",
    readTime: "10 min read",
    tags: ["Photography", "Safari", "Wildlife"],
    featured: true
  },
  {
    id: 4,
    title: "Best Time to Visit Uganda: Month by Month Guide",
    slug: "best-time-visit-uganda",
    excerpt: "Plan your perfect trip with our comprehensive guide to Uganda's seasons and wildlife viewing.",
    content: "Full content here...",
    category: "Travel Tips",
    image: "https://imgur.com/8u8WjGG.jpg",
    author: {
      name: "Esther Nakato",
      avatar: "https://imgur.com/ssIyPUG.jpg",
      role: "Travel Expert"
    },
    date: "2025-03-08",
    readTime: "12 min read",
    tags: ["Travel Planning", "Seasons", "Wildlife"],
    featured: false
  },
  {
    id: 5,
    title: "Cultural Experiences: Meeting Uganda's Tribes",
    slug: "uganda-tribes-cultural-experiences",
    excerpt: "Immerse yourself in the rich traditions and customs of Uganda's diverse tribal communities.",
    content: "Full content here...",
    category: "Culture",
    image: "https://imgur.com/5v6lVl8.jpg",
    author: {
      name: "John Mukasa",
      avatar: "https://imgur.com/9i40c9u.jpg",
      role: "Cultural Guide"
    },
    date: "2025-03-05",
    readTime: "9 min read",
    tags: ["Culture", "Tribes", "Local Life"],
    featured: false
  },
  {
    id: 6,
    title: "10 Must-Visit Places in Kampala",
    slug: "must-visit-places-kampala",
    excerpt: "Explore the top attractions and hidden corners of Uganda's vibrant capital city.",
    content: "Full content here...",
    category: "City Guide",
    image: "https://imgur.com/EzHnSsj.jpg",
    author: {
      name: "Sarah Namukasa",
      avatar: "https://imgur.com/lCTURxX.jpg",
      role: "City Guide"
    },
    date: "2025-03-20",
    readTime: "7 min read",
    tags: ["Kampala", "City Guide", "Urban Exploration"],
    featured: false
  },
  {
    id: 7,
    title: "Essential Self-Drive Safari Tips for Uganda",
    slug: "self-drive-safari-tips",
    excerpt: "Everything you need to know for planning and enjoying a successful self-drive safari in Uganda.",
    content: "Full content here...",
    category: "Safari Stories",
    image: "https://imgur.com/TvdP6Mt.jpg",
    author: {
      name: "Daniel Opio",
      avatar: "https://imgur.com/9i40c9u.jpg",
      role: "Self-Drive Safari Expert"
    },
    date: "2025-03-22",
    readTime: "9 min read",
    tags: ["Self-Drive Safari", "Travel Tips", "Road Trip"],
    featured: false
  },
  {
    id: 8,
    title: "Kampala's Best Street Food Guide",
    slug: "kampala-food-guide",
    excerpt: "Discover the most delicious street food in Kampala, from rolex to muchomo and everything in between.",
    content: "Full content here...",
    category: "Food & Culture",
    image: "https://imgur.com/4kwMnNu.jpg",
    author: {
      name: "Sarah Namukasa",
      avatar: "https://imgur.com/lCTURxX.jpg",
      role: "Food & Culture Guide"
    },
    date: "2025-03-25",
    readTime: "8 min read",
    tags: ["Food Guide", "Street Food", "Kampala", "Local Cuisine"],
    featured: false
  },
  {
    id: 9,
    title: "Kampala Nightlife Guide: Best Clubs, Bars & Entertainment",
    slug: "kampala-nightlife-guide",
    excerpt: "Experience Kampala after dark with our comprehensive guide to the city's vibrant nightlife scene.",
    content: "Full content here...",
    category: "Nightlife",
    image: "https://images.unsplash.com/photo-1566417713940-fe7c737a9ef2?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1829&q=80",
    author: {
      name: "Azel John Makumbi",
      avatar: "https://imgur.com/YTHr1B6.jpg",
      role: "Nightlife Expert"
    },
    date: "2025-04-10",
    readTime: "8 min read",
    tags: ["Nightlife", "Kampala", "Entertainment", "Clubs", "Bars"],
    featured: true
  },
  {
    id: 10,
    title: "The Ultimate Jinja Night Crawling Experience: Bars, Bites & Nile Adventures",
    slug: "jinja-night-crawling",
    excerpt: "Discover Jinja's vibrant nightlife scene with riverside bars, moonlit boat cruises, and street food markets in this 2025 guide.",
    content: "Full content here...",
    category: "Nightlife",
    image: "https://images.unsplash.com/photo-1470225620780-dba8ba36b745?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1740&q=80",
    author: {
      name: "Ankunda Prima",
      avatar: "https://imgur.com/ugLHrmP.jpg",
      role: "Nightlife Expert"
    },
    date: "2025-04-15",
    readTime: "12 min read",
    tags: ["Jinja nightlife", "Nile night boat party", "Street food", "Night activities"],
    featured: true
  },
  {
    id: 11,
    title: "Jinja Nightlife 2025: The ONLY Guide You Need",
    slug: "jinja-nightlife",
    excerpt: "Your comprehensive guide to Jinja's vibrant after-dark scene, from riverside bars to moonlight adventures on the Nile.",
    content: "Full content here...",
    category: "Nightlife",
    image: "https://images.unsplash.com/photo-1566737236500-c8ac43014a67?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1740&q=80",
    author: {
      name: "Ankunda Prima",
      avatar: "https://imgur.com/ugLHrmP.jpg",
      role: "Nightlife Expert"
    },
    date: "2025-04-20",
    readTime: "15 min read",
    tags: ["Jinja nightlife 2025", "Nile boat party", "Jinja bar crawl", "Uganda night clubs", "safe nightlife Jinja"],
    featured: true
  }
];

const Blog = () => {
  const [searchQuery, setSearchQuery] = useState('');
  const [selectedCategory, setSelectedCategory] = useState('All');
  const [email, setEmail] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [isSearchFocused, setIsSearchFocused] = useState(false);
  const postsPerPage = 6;
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = 'Blog | TravelCord';
    
    // Check for category in URL query params
    const params = new URLSearchParams(location.search);
    const category = params.get('category');
    if (category) {
      setSelectedCategory(category);
    }
  }, [location]);

  const handleSubscribe = async (e: React.FormEvent) => {
    e.preventDefault();
    try {
      const response = await fetch('/', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams({
          'form-name': 'newsletter-subscription',
          email
        }).toString()
      });

      if (response.ok) {
        alert('Thank you for subscribing to our newsletter!');
        setEmail('');
      } else {
        throw new Error('Subscription failed');
      }
    } catch (error) {
      console.error('Newsletter subscription error:', error);
      alert('There was an error subscribing to the newsletter. Please try again.');
    }
  };

  const handleShare = async (platform: string, url: string, title: string) => {
    const shareUrl = window.location.origin + url;
    
    switch (platform) {
      case 'facebook':
        window.open(`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(shareUrl)}`, '_blank');
        break;
      case 'twitter':
        window.open(`https://twitter.com/intent/tweet?url=${encodeURIComponent(shareUrl)}&text=${encodeURIComponent(title)}`, '_blank');
        break;
      case 'whatsapp':
        window.open(`https://api.whatsapp.com/send?text=${encodeURIComponent(title + ' ' + shareUrl)}`, '_blank');
        break;
      default:
        if (navigator.share) {
          try {
            await navigator.share({
              title,
              url: shareUrl
            });
          } catch (error) {
            console.error('Error sharing:', error);
          }
        }
    }
  };

  // Get all unique categories from blog posts
  const categories = [
    { name: "All", count: blogPosts.length },
    ...Array.from(new Set(blogPosts.map(post => post.category)))
      .map(category => ({
        name: category,
        count: blogPosts.filter(post => post.category === category).length
      }))
  ];

  // Filter posts based on search and category
  const filteredPosts = blogPosts.filter(post => {
    const matchesSearch = post.title.toLowerCase().includes(searchQuery.toLowerCase()) ||
                         post.excerpt.toLowerCase().includes(searchQuery.toLowerCase()) ||
                         post.tags.some(tag => tag.toLowerCase().includes(searchQuery.toLowerCase()));
    const matchesCategory = selectedCategory === 'All' || 
                           post.category === selectedCategory || 
                           (selectedCategory === 'safari-stories' && post.category.includes('Safari')) ||
                           (selectedCategory === 'city-guides' && post.category.includes('City')) ||
                           (selectedCategory === 'cultural-insights' && post.category.includes('Culture'));
    return matchesSearch && matchesCategory;
  });

  // Calculate pagination
  const indexOfLastPost = currentPage * postsPerPage;
  const indexOfFirstPost = indexOfLastPost - postsPerPage;
  const currentPosts = filteredPosts.slice(indexOfFirstPost, indexOfLastPost);
  const totalPages = Math.ceil(filteredPosts.length / postsPerPage);

  // Featured posts
  const featuredPosts = blogPosts.filter(post => post.featured);

  return (
    <>
      <Navbar />
      
      {/* Hero Section */}
      <section className="relative bg-gray-900 text-white overflow-hidden">
        <div className="absolute inset-0">
          <img 
            src="https://imgur.com/LUalhrs.jpg"
            alt="Blog hero"
            className="w-full h-full object-cover opacity-30"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/80 via-black/50 to-black/80"></div>
        </div>
        
        <div className="relative max-w-7xl mx-auto px-4 py-16 sm:px-6 lg:px-8">
          <div className="mb-4">
            <Link to="/" className="inline-flex items-center text-white/90 hover:text-white">
              <ArrowLeft className="h-4 w-4 mr-1" />
              Back to Home
            </Link>
          </div>
          
          <div className="max-w-3xl">
            <motion.h1 
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5 }}
              className="text-4xl font-bold mb-4"
            >
              Uganda Safari & Travel Blog
            </motion.h1>
            <motion.p 
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.2 }}
              className="text-lg text-white/90 mb-6"
            >
              Expert guides, tips, and stories about gorilla trekking, game drives, self-drive safaris, and cultural experiences across Uganda. Plan your perfect safari adventure with our comprehensive resources.
            </motion.p>
            
            <motion.div 
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.4 }}
              className={`relative transition-all duration-300 ${isSearchFocused ? 'scale-105' : ''}`}
            >
              <Search className={`absolute left-3 top-1/2 transform -translate-y-1/2 h-5 w-5 transition-colors duration-300 ${
                isSearchFocused ? 'text-ta-green' : 'text-gray-400'
              }`} />
              <input
                type="text"
                placeholder="Search safari guides, gorilla trekking, game drives..."
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                onFocus={() => setIsSearchFocused(true)}
                onBlur={() => setIsSearchFocused(false)}
                className="pl-10 w-full rounded-lg bg-white/10 border border-white/20 text-white placeholder-white/60 focus:ring-ta-green focus:border-ta-green transition-all duration-300"
              />
            </motion.div>
          </div>
        </div>
      </section>

      {/* Featured Posts */}
      <section className="py-12 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-2xl font-bold text-gray-900 mb-8">Featured Uganda Safari Stories</h2>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {featuredPosts.map((post, index) => (
              <motion.div
                key={post.id}
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
                className="group bg-white rounded-lg border border-gray-200 overflow-hidden hover:shadow-lg transition-all duration-300"
              >
                <div className="relative h-48">
                  <img 
                    src={post.image} 
                    alt={post.title}
                    className="w-full h-full object-cover transform group-hover:scale-105 transition-transform duration-500"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/70 to-transparent group-hover:from-black/80 transition-all duration-300"></div>
                  <div className="absolute top-2 left-2 bg-ta-green text-white text-xs px-2 py-1 rounded-full">
                    {post.category}
                  </div>
                </div>
                
                <div className="p-4">
                  <div className="flex items-center mb-2">
                    <img 
                      src={post.author.avatar} 
                      alt={post.author.name}
                      className="h-6 w-6 rounded-full"
                    />
                    <div className="ml-2">
                      <span className="text-sm font-medium text-gray-900">{post.author.name}</span>
                      <span className="text-xs text-gray-500 block">{post.author.role}</span>
                    </div>
                  </div>
                  
                  <h3 className="text-lg font-semibold text-gray-900 mb-2 group-hover:text-ta-green transition-colors">
                    {post.title}
                  </h3>
                  
                  <p className="text-sm text-gray-600 mb-4 line-clamp-2">{post.excerpt}</p>
                  
                  <div className="flex items-center justify-between text-sm text-gray-500">
                    <div className="flex items-center">
                      <Calendar className="h-4 w-4 mr-1" />
                      {new Date(post.date).toLocaleDateString('en-US', {
                        month: 'short',
                        day: 'numeric',
                        year: 'numeric'
                      })}
                    </div>
                    <div className="flex items-center">
                      <Clock className="h-4 w-4 mr-1" />
                      {post.readTime}
                    </div>
                  </div>
                  
                  <div className="flex flex-wrap gap-2 mt-4">
                    {post.tags.slice(0, 2).map((tag, index) => (
                      <span 
                        key={index}
                        className="px-2 py-1 bg-gray-100 text-gray-600 rounded-full text-xs hover:bg-ta-green hover:text-white transition-colors cursor-pointer"
                      >
                        {tag}
                      </span>
                    ))}
                    {post.tags.length > 2 && (
                      <span className="px-2 py-1 bg-gray-100 text-gray-600 rounded-full text-xs">
                        +{post.tags.length - 2}
                      </span>
                    )}
                  </div>

                  <div className="flex items-center justify-between mt-4 pt-4 border-t border-gray-100">
                    <div className="flex items-center space-x-2">
                      <FacebookShareButton
                        url={`${window.location.origin}/blog/${post.slug}`}
                        quote={post.title}
                        className="p-1.5 text-gray-400 hover:text-blue-600 transition-colors"
                      >
                        <Facebook className="h-4 w-4" />
                      </FacebookShareButton>
                      <TwitterShareButton
                        url={`${window.location.origin}/blog/${post.slug}`}
                        title={post.title}
                        className="p-1.5 text-gray-400 hover:text-blue-400 transition-colors"
                      >
                        <svg className="h-4 w-4" viewBox="0 0 24 24" fill="currentColor">
                          <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
                        </svg>
                      </TwitterShareButton>
                      <WhatsappShareButton
                        url={`${window.location.origin}/blog/${post.slug}`}
                        title={post.title}
                        className="p-1.5 text-gray-400 hover:text-green-600 transition-colors"
                      >
                        <Share2 className="h-4 w-4" />
                      </WhatsappShareButton>
                    </div>
                    <Link
                      to={`/blog/${post.slug}`}
                      className="text-ta-green text-sm hover:underline flex items-center"
                    >
                      Read More
                      <svg className="w-4 h-4 ml-1" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M9 6L15 12L9 18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                      </svg>
                    </Link>
                  </div>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* Main Content */}
      <section className="py-12 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
            {/* Blog Posts */}
            <div className="lg:col-span-2">
              <div className="space-y-6">
                {currentPosts.map((post, index) => (
                  <motion.div
                    key={post.id}
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.5, delay: index * 0.1 }}
                    className="group bg-white rounded-lg border border-gray-200 overflow-hidden hover:shadow-lg transition-all duration-300"
                  >
                    <div className="flex flex-col md:flex-row">
                      <div className="md:w-1/3">
                        <div className="relative h-48 md:h-full">
                          <img 
                            src={post.image} 
                            alt={post.title}
                            className="w-full h-full object-cover transform group-hover:scale-105 transition-transform duration-500"
                          />
                          <div className="absolute top-2 left-2 bg-ta-green text-white text-xs px-2 py-1 rounded-full">
                            {post.category}
                          </div>
                        </div>
                      </div>
                      
                      <div className="md:w-2/3 p-4">
                        <div className="flex items-center mb-2">
                          <img 
                            src={post.author.avatar} 
                            alt={post.author.name}
                            className="h-8 w-8 rounded-full"
                          />
                          <div className="ml-2">
                            <span className="text-sm font-medium text-gray-900">{post.author.name}</span>
                            <span className="text-xs text-gray-500 block">{post.author.role}</span>
                          </div>
                        </div>
                        
                        <h3 className="text-xl font-semibold text-gray-900 mb-2 group-hover:text-ta-green transition-colors">
                          {post.title}
                        </h3>
                        
                        <p className="text-sm text-gray-600 mb-4">{post.excerpt}</p>
                        
                        <div className="flex items-center justify-between text-sm text-gray-500 mb-4">
                          <div className="flex items-center">
                            <Calendar className="h-4 w-4 mr-1" />
                            {new Date(post.date).toLocaleDateString('en-US', {
                              month: 'short',
                              day: 'numeric',
                              year: 'numeric'
                            })}
                          </div>
                          <div className="flex items-center">
                            <Clock className="h-4 w-4 mr-1" />
                            {post.readTime}
                          </div>
                        </div>
                        
                        <div className="flex flex-wrap gap-2 mb-4">
                          {post.tags.slice(0, 2).map((tag, index) => (
                            <span 
                              key={index}
                              className="px-2 py-1 bg-gray-100 text-gray-700 rounded-full text-sm hover:bg-ta-green hover:text-white transition-colors cursor-pointer"
                            >
                              {tag}
                            </span>
                          ))}
                          {post.tags.length > 2 && (
                            <span className="px-2 py-1 bg-gray-100 text-gray-600 rounded-full text-xs">
                              +{post.tags.length - 2}
                            </span>
                          )}
                        </div>
                        
                        <div className="flex items-center justify-between">
                          <div className="flex items-center space-x-2">
                            <FacebookShareButton
                              url={`${window.location.origin}/blog/${post.slug}`}
                              quote={post.title}
                              className="p-1.5 text-gray-400 hover:text-blue-600 transition-colors"
                            >
                              <Facebook className="h-4 w-4" />
                            </FacebookShareButton>
                            <TwitterShareButton
                              url={`${window.location.origin}/blog/${post.slug}`}
                              title={post.title}
                              className="p-1.5 text-gray-400 hover:text-blue-400 transition-colors"
                            >
                              <svg className="h-4 w-4" viewBox="0 0 24 24" fill="currentColor">
                                <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
                              </svg>
                            </TwitterShareButton>
                            <WhatsappShareButton
                              url={`${window.location.origin}/blog/${post.slug}`}
                              title={post.title}
                              className="p-1.5 text-gray-400 hover:text-green-600 transition-colors"
                            >
                              <Share2 className="h-4 w-4" />
                            </WhatsappShareButton>
                          </div>
                          <Link
                            to={`/blog/${post.slug}`}
                            className="text-ta-green text-sm hover:underline flex items-center"
                          >
                            Read More
                            <svg className="w-4 h-4 ml-1" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M9 6L15 12L9 18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                            </svg>
                          </Link>
                        </div>
                      </div>
                    </div>
                  </motion.div>
                ))}
              </div>
              
              {/* Pagination */}
              {totalPages > 1 && (
                <div className="mt-8 flex justify-center space-x-2">
                  {Array.from({ length: totalPages }, (_, i) => i + 1).map((page) => (
                    <button
                      key={page}
                      onClick={() => setCurrentPage(page)}
                      className={`px-3 py-1 rounded-md text-sm font-medium transition-colors ${
                        currentPage === page
                          ? 'bg-ta-green text-white'
                          : 'bg-white text-gray-700 hover:bg-gray-100'
                      }`}
                    >
                      {page}
                    </button>
                  ))}
                </div>
              )}
            </div>
            
            {/* Sidebar */}
            <div className="lg:col-span-1 space-y-6">
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5 }}
                className="bg-white rounded-lg border border-gray-200 p-4"
              >
                <h3 className="text-lg font-semibold text-gray-900 mb-4">Categories</h3>
                <div className="space-y-2">
                  {categories.map((category, index) => (
                    <button
                      key={index}
                      onClick={() => setSelectedCategory(category.name)}
                      className={`w-full flex items-center justify-between px-3 py-2 rounded-lg transition-colors ${
                        selectedCategory === category.name
                          ? 'bg-ta-green text-white'
                          : 'hover:bg-gray-50'
                      }`}
                    >
                      <span>{category.name}</span>
                      <span className="text-sm">{category.count}</span>
                    </button>
                  ))}
                </div>
              </motion.div>
              
              {/* Newsletter Signup */}
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, delay: 0.2 }}
                className="bg-white rounded-lg border border-gray-200 p-4"
              >
                <h3 className="text-lg font-semibold text-gray-900 mb-2">Safari Updates Newsletter</h3>
                <p className="text-sm text-gray-600 mb-4">
                  Subscribe for the latest Uganda safari tips, gorilla trekking updates, and travel guides.
                </p>
                <form onSubmit={handleSubscribe}>
                  <div className="relative">
                    <Mail className="absolute left-3 top-1/2 transform -translate-y-1/2 h-5 w-5 text-gray-400" />
                    <input
                      type="email"
                      placeholder="Your email address"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      className="pl-10 w-full rounded-lg border border-gray-300 focus:ring-ta-green focus:border-ta-green"
                      required
                    />
                  </div>
                  <button
                    type="submit"
                    className="mt-3  w-full py-2 bg-ta-green text-white rounded-lg hover:bg-ta-green-dark transition-colors flex items-center justify-center"
                  >
                    Subscribe
                    <svg className="w-4 h-4 ml-1" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M9 6L15 12L9 18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                  </button>
                </form>
              </motion.div>
              
              {/* Popular Topics */}
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, delay: 0.4 }}
                className="bg-white rounded-lg border border-gray-200 p-4"
              >
                <h3 className="text-lg font-semibold text-gray-900 mb-4">Popular Safari Topics</h3>
                <div className="grid grid-cols-2 gap-4">
                  <div className="bg-gray-50 p-3 rounded-lg hover:bg-gray-100 transition-colors cursor-pointer">
                    <Camera className="h-5 w-5 text-ta-green mb-2" />
                    <h4 className="font-medium text-gray-900">Gorilla Trekking</h4>
                    <p className="text-xs text-gray-600">Permits & experiences</p>
                  </div>
                  <div className="bg-gray-50 p-3 rounded-lg hover:bg-gray-100 transition-colors cursor-pointer">
                    <Compass className="h-5 w-5 text-ta-green mb-2" />
                    <h4 className="font-medium text-gray-900">Game Drives</h4>
                    <p className="text-xs text-gray-600">Wildlife viewing</p>
                  </div>
                  <div className="bg-gray-50 p-3 rounded-lg hover:bg-gray-100 transition-colors cursor-pointer">
                    <Coffee className="h-5 w-5 text-ta-green mb-2" />
                    <h4 className="font-medium text-gray-900">Self-Drive</h4>
                    <p className="text-xs text-gray-600">Road trip guides</p>
                  </div>
                  <div className="bg-gray-50 p-3 rounded-lg hover:bg-gray-100 transition-colors cursor-pointer">
                    <Users className="h-5 w-5 text-ta-green mb-2" />
                    <h4 className="font-medium text-gray-900">Culture</h4>
                    <p className="text-xs text-gray-600">Tribal traditions</p>
                  </div>
                  <div className="bg-gray-50 p-3 rounded-lg hover:bg-gray-100 transition-colors cursor-pointer">
                    <Moon className="h-5 w-5 text-purple-600 mb-2" />
                    <h4 className="font-medium text-gray-900">Nightlife</h4>
                    <p className="text-xs text-gray-600">Kampala & Jinja after dark</p>
                  </div>
                  <div className="bg-gray-50 p-3 rounded-lg hover:bg-gray-100 transition-colors cursor-pointer">
                    <Sun className="h-5 w-5 text-ta-green mb-2" />
                    <h4 className="font-medium text-gray-900">Best Season</h4>
                    <p className="text-xs text-gray-600">When to visit</p>
                  </div>
                </div>
              </motion.div>
              
              {/* Social Media */}
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, delay: 0.6 }}
                className="bg-white rounded-lg border border-gray-200 p-4"
              >
                <h3 className="text-lg font-semibold text-gray-900 mb-4">Follow Us</h3>
                <div className="flex justify-around">
                  <a 
                    href="https://facebook.com/travelcord"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="p-2 text-gray-600 hover:text-blue-600 transition-colors transform hover:scale-110"
                  >
                    <Facebook className="h-6 w-6" />
                  </a>
                  <a 
                    href="https://instagram.com/travelcord"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="p-2 text-gray-600 hover:text-pink-600 transition-colors transform hover:scale-110"
                  >
                    <Instagram className="h-6 w-6" />
                  </a>
                  <a 
                    href="https://wa.me/256766830194"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="p-2 text-gray-600 hover:text-green-600 transition-colors transform hover:scale-110"
                  >
                    <Share2 className="h-6 w-6" />
                  </a>
                </div>
              </motion.div>
              
              {/* Write for Us */}
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, delay: 0.8 }}
                className="bg-white rounded-lg border border-gray-200 p-4"
              >
                <h3 className="text-lg font-semibold text-gray-900 mb-2">Write for Us</h3>
                <p className="text-sm text-gray-600 mb-4">
                  Are you a safari guide or travel enthusiast? Share your Uganda stories and experiences with our community.
                </p>
                <Link
                  to="/write-for-us"
                  className="inline-flex items-center text-ta-green hover:text-ta-green-dark group"
                >
                  Learn More
                  <svg className="w-4 h-4 ml-1 group-hover:translate-x-1 transition-transform" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M9 6L15 12L9 18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </Link>
              </motion.div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </>
  );
};

export default Blog;